import React from 'react';
import AgGridActionsDropdown, {
  type AgGridActionsDropdownItem,
} from '../AgGridActionsDropdown/AgGridActionsDropdown';
import { GridDataFreshnessLabel } from '../GridDataFreshnessLabel';
import { normalizeLastUpdatedAt } from 'Core-utils/helpers/pageHints';
import './AgGridTableHeader.scss';
import { Typography } from 'Components/atoms';

export type { AgGridActionsDropdownItem };

export interface AgGridTableHeaderProps {
  /** Primary label on the left (e.g. table title). */
  title?: React.ReactNode;
  /** Extra content in the left section after the title (e.g. inline row counts). */
  leftExtras?: React.ReactNode;
  /** Content in the right section before the actions menu (e.g. row counts). */
  rightExtras?: React.ReactNode;
  /** Dropdown menu items; omitted or empty with hideActions suppresses the menu. */
  actionItems?: AgGridActionsDropdownItem[];
  /** When true, the Actions dropdown is not rendered. */
  hideActions?: boolean;
  /** ISO timestamp from API hints.lastUpdatedAt — shown below counts/actions. */
  lastUpdatedAt?: string | null;
  className?: string;
}

const AgGridTableHeader: React.FC<AgGridTableHeaderProps> = ({
  title,
  leftExtras,
  rightExtras,
  actionItems,
  hideActions = false,
  lastUpdatedAt,
  className,
}) => {
  const showActions = !hideActions && Array.isArray(actionItems) && actionItems.length > 0;
  const validatedLastUpdatedAt = normalizeLastUpdatedAt(lastUpdatedAt);

  return (
    <div className={['ag-grid-table-header-stack', className].filter(Boolean).join(' ')}>
      <div className={['ag-grid-table-header'].filter(Boolean).join(' ')}>
        <div className="ag-grid-table-header__section ag-grid-table-header__section--start">
          {title !== null && title !== undefined && title !== '' && (
            <div className="ag-grid-table-header__title">
              <Typography variant="body11" color="text-high-emphasis">{title}</Typography>
            </div>
          )}
          {leftExtras}
        </div>
        <div className="ag-grid-table-header__section ag-grid-table-header__section--end">
          {rightExtras}
          {showActions && <AgGridActionsDropdown items={actionItems} />}
        </div>
      </div>
      {validatedLastUpdatedAt ? (
        <div className="ag-grid-table-header__subheader">
          <GridDataFreshnessLabel lastUpdatedAt={validatedLastUpdatedAt} />
        </div>
      ) : null}
    </div>
  );
};

export default AgGridTableHeader;
